import React from "react";
import { Link } from "react-router-dom";
import { CustomerServiceSidebar } from "./Delivery";
import "../css/content-page.scss";

function CookiePolicy() {
  return (
    <main className="content-page">
      <div className="content-page__shell">
        <CustomerServiceSidebar currentPath="/cookies" />
        <article className="content-page__article" aria-labelledby="cookies-title">
          <header className="content-page__header">
            <p className="content-page__eyebrow">Your browser choices</p>
            <h1 id="cookies-title">Cookie Policy</h1>
            <p className="content-page__lead">This policy explains the browser storage currently used by sickzuno.</p>
          </header>
          <p className="content-page__meta">Last updated: September 16, 2026</p>
          <section className="content-page__section">
            <h2>1. What we use</h2>
            <p>The current storefront uses local browser storage to remember cart contents. The application code does not set advertising or cross-site tracking cookies.</p>
          </section>
          <section className="content-page__section">
            <h2>2. Essential storage</h2>
            <p>Cart records contain product selections, variants, packaging choices and quantities. This storage supports the shopping experience and remains on your device until the cart or site data is cleared.</p>
          </section>
          <section className="content-page__section">
            <h2>3. Managing your choices</h2>
            <p>You can clear or block site storage using your browser settings. Blocking storage may prevent cart contents from remaining available between visits.</p>
          </section>
          <section className="content-page__section">
            <h2>4. Future services</h2>
            <p>If analytics, advertising, payment or other third-party services are added, this policy and any required consent controls must be updated before those services are enabled.</p>
          </section>
          <section className="content-page__section">
            <h2>5. Questions</h2>
            <p>Email <a className="content-page__inline-link" href="mailto:harv@sickzuno.online">harv@sickzuno.online</a> or review our <Link className="content-page__inline-link" to="/privacy">Privacy Policy</Link>.</p>
          </section>
        </article>
      </div>
    </main>
  );
}

export default CookiePolicy;
